/* eslint-disable react-native/no-inline-styles */
import React, { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import {
  BottomDocked,
  Button,
  Content,
  Divider,
  H3,
  Page,
  Row,
  Spacer,
  Text,
} from '../components'
import InputComp from '../components/Input/Input'
import T from '../components/T'
import { Config } from '../const'
import useClipboard from '../hooks/useClipboard'
import useShare from '../hooks/useShare'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import { useT } from '../state/language'
import { getFavorites, importFavs } from '../state/timetable/timetableSlice'
import ReloadApp from './ReloadApp'

const Input = styled(InputComp)`
  &&& {
    background: black;
  }
`

const useMailText = (favorites) => {
  const t = useT()
  const favoritesStr = useMemo(() => JSON.stringify(favorites), [favorites])
  const favoritesForLink = favorites.join('-')

  const shareUrl = Config.REACT_APP_IS_FUSION
    ? t('FAVORITES_SHARE_URL_FUSION')
    : t('FAVORITES_SHARE_URL_AT_TENSION')

  const subject = t('FAVORITES_SHARE_TITLE')
  const link = shareUrl + '/#/import/' + encodeURIComponent(favoritesForLink)
  const mailBody = useMemo(
    () => `${t('FAVORITES_SHARE_TEXT', link)}

    --- START ---
    ${favoritesStr}
    --- ENDE ---

    ${shareUrl}
    `,
    [favoritesStr, link, shareUrl, t],
  )

  const mailTo = `mailto:?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(mailBody)}`

  return {
    favoritesStr,
    //  subject,
    mailBody,
    mailTo,
  }
}

const ImportExport = () => {
  const dispatch = useAppDispatch()

  const favorites = useAppSelector(getFavorites)

  const [importTxt, setImportTxt] = useState('')
  const [error, setError] = useState('')
  const t = useT()
  const navigate = useNavigate()

  const { favoritesStr, mailBody, mailTo } = useMailText(favorites)

  const [, setClipboard] = useClipboard(favoritesStr)

  const validateImport = useCallback(() => {
    // console.log('validateImport')
    try {
      let str = importTxt

      try {
        const regEx = new RegExp('(?<=--- START ---)(.*)(?=--- ENDE ---)', 's')
        const matched = importTxt.match(regEx)
        if (matched && matched[0]) {
          str = matched[0]
        }
      } catch (err) {}

      str = str.trim()
      // console.log('cleanString:', str)

      const newFavorites = JSON.parse(str)

      // console.log('Importiere: ', newFavorites)
      dispatch(importFavs(newFavorites))
      setError('')
      alert(`${newFavorites.length} ${t('FAVORITES_IMPORT_SUCCESS')}`)
      setImportTxt('')
    } catch (err: any) {
      setError(t('FAVORITES_IMPORT_ERROR') + ' :: ' + err.toString())
      console.warn(err)
    }
  }, [importTxt, dispatch, t])

  const share = useShare(mailBody)

  return (
    <Page>
      <Content>
        <H3>
          <T id="FAVORITES_EXPORT_HEADLINE" />
        </H3>

        <Spacer size={2} />
        {!!navigator.share ? (
          <React.Fragment>
            <Text>
              <T id="FAVORITES_SHARE_DESC" />
            </Text>
            <Spacer size={2} />
            <Button onClick={share}>
              <T id="FAVORITES_SHARE_BTN" />
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Text>
              <T id="FAVORITES_EMAIL_DESC" />
            </Text>

            <Spacer size={2} />

            <Button as="a" href={mailTo} style={{ display: 'inline-block' }}>
              <T id="FAVORITES_EMAIL_BTN" />
            </Button>
          </React.Fragment>
        )}

        <Spacer size={2} />
        <Text>
          <T id="FAVORITES_CLIPBOARD_DESC" />
        </Text>
        <Spacer size={2} />
        <Button
          onClick={() => {
            setClipboard()
            alert(t('FAVORITES_COPY_CLIPBOARD_SUCCESS'))
          }}
        >
          <T id="FAVORITES_CLIPBOARD_BTN" />
        </Button>

        <Spacer size={4} />
        <Divider />
        <Spacer size={4} />

        <H3 $mb={2}>
          <T id="FAVORITES_IMPORT_HEADLINE" />
        </H3>
        <Text $mb={2}>
          <T id="FAVORITES_IMPORT_DESC" />
        </Text>

        <Input
          value={importTxt}
          onChange={(value) => setImportTxt(value)}
          placeholder="Paste your favorites here"
          disabled={false}
          autoFocus={true}
          className=""
          onEnter={() => {}}
        />
        <Spacer />
        {error && <Text>{error}</Text>}
        <Button flex="initial" onClick={validateImport}>
          <T id="FAVORITES_IMPORT_BTN" />
        </Button>

        <Spacer size={4} />
        <Divider />
        <Spacer size={4} />
        <ReloadApp />
      </Content>
      <BottomDocked>
        <Row>
          <Button onClick={() => navigate(-1)}>
            <T id="FAVORITES_CLOSE_BTN" />
          </Button>
        </Row>
      </BottomDocked>
    </Page>
  )
}

export default ImportExport
